import { styled } from "@mui/material/styles";

export const StyledInput = styled("input")(({ theme }) => ({
  border: "#fff 2px solid",
  borderRadius: "8px",
  fontFamily: "inherit",
  padding: "15px",
  color: "#717680",
  fontSize: "14px",
  transition: "all 0.2s ease-in",
  appearance: "none",

  '&[type="number"]': {
    width: "100px",
    textAlign: "right",
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    "&[type=number]": {
      MozAppearance: "textfield", // Firefox
    },
  },

  // 🎯 Checkbox input
  '&[type="checkbox"]': {
    margin: 0,
    width: "22px",
    height: "22px",
    padding: "5px",
    border: "0.1em solid #fff",
    borderRadius: "6px",
    transform: "translateY(-0.075em)",
    placeContent: "center",
    cursor: "pointer",
    "&:before": {
      content: '""',
      width: "10px",
      height: "10px",
      clipPath: "polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%)",
      transform: "scale(0)",
      transformOrigin: "bottom left",
      transition: "120ms transform ease-in-out",
      boxShadow: `inset 1em 1em #030039`,
      backgroundColor: "red",
      display: "block",
    },
    "&:checked": {
      background: `${theme.palette.background.button_primary}`,
      borderColor: `${theme.palette.background.button_primary}`,
      "&:before": {
        transform: "scale(1)",
      },
    },
    "& + span": {
      marginRight: "5px",
      "& + a": {
        color: "#D1C7FF",
        textDecoration: "none",
      },
    },
  },

  "&[type='radio']": {
    "-webkit-appearance": "none", // Removed leading space
    appearance: "none", // Changed from "" to "none"
    backgroundColor: "#fff",
    margin: 0,
    font: "inherit",
    width: "20px",
    height: "20px",
    border: `1px solid #211F45`,
    borderRadius: "50%",
    transform: "translateY(-0.075em)",
    padding: "8px",
    // Added Grid to effortlessly center the inner dot
    display: "grid",
    placeContent: "center",

    "&::before": {
      content: '""',
      width: "0.8em", // Made smaller than the container so it looks like a dot
      height: "0.8em",
      borderRadius: "50%",
      transform: "scale(0)",
      transition: "120ms transform ease-in-out",
      boxShadow: `inset 1em 1em #211F45`, // backgroundColor: "red" also works here
      marginLeft: "0.5px"
    },
    "&:checked": {
      borderColor: theme.palette.background.button_primary,
    },
    // Combined the selectors instead of nesting them
    "&:checked::before": {
      transform: "scale(1)",
    },
  },

  // 🎯 Text input (default)
  '&[type="text"], &[type="password"], &[type="email"]': {
    width: "100%",
    "&:focus": {
      outline: "none",
      border: `${theme.palette.background.button_primary} 2px solid`,
    },
    "&.invalid-input": {
      border: `${theme.palette.text.warning_primary} 2px solid`,
    },
    "& + .password-toggler": {
      position: "absolute",
      border: 0,
      background: "transparent",
      color: "#000",
      right: "15px",
      top: "29%",
      width: "auto",
      textAlign: "right",
      padding: 0,
      cursor: "pointer",
      "& svg": {
        width: "25px",
        height: "25px",
      },
    },
  },
  // 🎯 Email input
  '&[type="email"]': {
    width: "100%",
  },
}));
